import { baseApi } from "../baseApi";

export const supplierApi = baseApi.injectEndpoints({
     endpoints: (builder) => ({
        getDoctypeDetails: builder.query({
            query: (params) => ({
                url: `/api/method/frappe.client.get`,
                params: params
            })
        }),
        getSupplierGroups: builder.query({
            query: ({ start = 0, limit = 12,filters = []  }) => ({
                url: 'api/resource/Supplier Group',
                params: {
                    fields: JSON.stringify(["name", "parent_supplier_group", "creation"]),
                    limit_start: start,
                    limit_page_length: limit,
                    order_by: "`tabSupplier Group`.`modified` desc",
                    ...(filters.length > 0 && { filters: JSON.stringify(filters) }),
                },
            }),
            providesTags: ['supplier']
        }),
        getSupplierGroupCount: builder.query({
            query: () => ({
                url: '/api/method/frappe.client.get_count',
                params: {
                    doctype: 'Supplier Group',
                },
            }),
        }),
        getGroupOnlySupplierGroups: builder.query({
            query: () => ({
                url: '/api/resource/Supplier Group',
                params: {
                    filters: JSON.stringify([["is_group", "=", 1]]),
                },
            }),
        }),
        getPaymentandTerms: builder.query({
            query: () => ({
                url: `/api/resource/Payment Terms Template`,
            })
        }),
        getAllcompany: builder.query({
            query: () => ({
                url: `/api/resource/Company`,
            })
        }),
        getLiabilityAccountsByCompany: builder.query({
            query: (company) => ({
                url: `/api/resource/Account`,
                params: {
                    filters: JSON.stringify([
                        ["root_type", "=", "Liability"],
                        ["account_type", "=", "Payable"],
                        ["company", "=", company]
                    ]),
                },
            }),
        }),
        createSupplierGroup: builder.mutation({
            query: (payload) => ({
                url: `/api/resource/Supplier Group`,
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: ['supplier']
        }),
        getSupplierGroupByName: builder.query({
            query: (name) => `/api/resource/Supplier Group/${encodeURIComponent(name)}`,
            providesTags: ['supplier']
        }),
        updateSupplierGroup: builder.mutation({
            query: ({ name, payload }) => ({
                url: `/api/resource/Supplier Group/${encodeURIComponent(name)}`,
                method: 'PUT',
                body: payload,
            }),
            invalidatesTags: ['supplier']
        }),
    })
});

export const { useUpdateSupplierGroupMutation, useGetSupplierGroupByNameQuery, useCreateSupplierGroupMutation, useLazyGetLiabilityAccountsByCompanyQuery, useGetLiabilityAccountsByCompanyQuery, useGetAllcompanyQuery, useGetPaymentandTermsQuery, useGetGroupOnlySupplierGroupsQuery, useGetSupplierGroupCountQuery, useUpdateBrandMutation, useGetSupplierGroupsQuery } = supplierApi


